/**
 * @ngdoc service
 * @name checkins.factory:addRsvpsToPicklists
 * @description
 *
 */
angular
    .module('festzelt-os.guestlists')
    .factory('addRsvpsToPicklists', [
        'locale',
        'Alert',
        'SweetAlert',
        'SelectBox',
        'Picklists',
        '$http',
        addRsvpsToPicklists
    ]);

function addRsvpsToPicklists(locale, Alert, SweetAlert, SelectBox, Picklists, $http) {
    return {
        key: 'add-rsvps-to-picklists',
        title: 'Add to Picklist(s)',
        level: 'selected',
        action: addToPicklist
    };

    function addToPicklist(action, store) {
        return locale.ready(['picklists', 'sweetalerts'])
            .then(() => {
                SelectBox.multiple(Picklists, {
                    displayField: 'name_with_count'
                }).then(response => {
                    $http.post('picklists/rsvps', {
                        picklists: {
                            count: response.data.length,
                            filters: [
                                {
                                    field: 'id',
                                    operator: 'IN',
                                    value: response.data
                                }
                            ]
                        },
                        rsvps: store.getters.selectedFilters
                    }).then(() => {
                        store.dispatch('getData');
                        Alert.success(locale.getString('sweetalerts.add_successful'), locale.getString('picklists.rsvps_added'));
                    }, err => Alert.handle(err))
                }, err => Alert.handle(err));
            });
    }

}

/**
 * @ngdoc service
 * @name festzelt-os.guestlists.factory:addToAddressbook
 * @description
 */

class addRsvpsToAddressbook {
    constructor(Alert, $http, SweetAlert) {
        this.key = 'add-to-addressbook';
        this.level = 'selected';
        this.icon = 'address-book';
        this.title = 'Add to address book';
        this.alert = Alert;
        this.api = $http;
        this.sweetAlert = SweetAlert;
        this.accessor = (rsvp) => {
            return !rsvp.contact.data.addressbook;
        };
    }

    action(action, store) {
        // @todo new alert - don't add, probably not used
        console.log(store, action);
        this.alert.confirm({
            title: `Add to address book?`,
            message: `Please confirm adding the contacts of ${store.getters.selectedCount} rsvps to address book`,
            confirmBtn: 'Add To Address Book',
            confirmBtnColor: '#9C63FF'
        }).then(() => {
            return this.api.put(`contacts`, {
                relationship: 'rsvp',
                items: store.getters.selectedFilters,
                fields: {
                    addressbook: true
                }
            }).then(response => {
                this.sweetAlert.success('Success', 'The contacts have been added to the address book');
            }, err => this.alert.handle(err));
        }, err => this.alert.handle(err));
    }
}

angular
    .module('festzelt-os.guestlists')
    .factory('addToAddressbook', [
        'Alert',
        '$http',
        'SweetAlert',
        (Alert, $http, SweetAlert) => new addRsvpsToAddressbook(Alert, $http, SweetAlert)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/add-rsvps-to-picklists.js